(() => {
  const AVATAR_PROFILE_REFRESH_ATTEMPTS = 15;
  const AVATAR_PROFILE_REFRESH_INTERVAL_MS = 1000;
  const roots = document.querySelectorAll('[data-zj-my-business]');
  if (!roots.length) return;

  const copy = {
    zh: {
      categories: { active: '进行中', inquiry: '询盘中', pending_payment: '待付款', paid: '已付款', awaiting_receipt: '待收货', completed: '已完成', after_sales: '售后', cancelled: '已取消', all: '全部' },
      empty: { active: '暂无进行中的业务', all: '暂无业务记录', inquiry: '暂无正在洽谈的业务', pending_payment: '暂无待付款交易', paid: '暂无已付款交易', awaiting_receipt: '暂无待收货交易', completed: '暂无已完成交易', after_sales: '暂无售后记录', cancelled: '暂无已取消交易' }, unavailable: '业务信息暂时无法加载，请稍后重试。',
      businessReference: '业务编号', draftOrderNumber: '起草订单', orderNumber: '订单号', quantity: '数量', amount: '金额', updated: '最近更新', cancelledAt: '取消时间', completedAt: '完成时间', manager: '客户经理', paymentStatus: '付款状态', fulfillmentStatus: '履约状态', shippingStatus: '物流状态', trackingCompany: '承运商', trackingNumber: '物流单号',
      logistics: '物流详情', shippedAt: '发出时间', handedOverAt: '交付时间', deliveredAt: '送达时间', trackingPending: '物流信息待补充', viewPackage: '查看物流', responsibilityEnded: '我方物流责任已完成。', handedOverResponsibilityEnded: '已交付客户指定货代，我方物流责任已完成。', packageLabel: (index) => `包裹 ${index}`,
      logisticsTypes: { domestic: '国内运输', international: '国际运输', last_mile: '末端派送', other: '物流运输' },
      logisticsStatuses: { pending: '待发运', shipped: '已发货', in_transit: '运输中', handed_over: '已交付货代', delivered: '已送达', cancelled: '已取消', replaced: '已替换' },
      continue: '继续沟通', message: '发消息', pay: '立即付款', continuePayment: '继续付款', continuingPayment: '恢复中…', confirmReceipt: '确认收货', confirmingReceipt: '确认中…', cancel: '取消订单', cancelInquiry: '取消询盘', inquiryType: '询盘', order: '查看订单', shipping: '查看物流', shippingUnavailable: '物流详情暂不可用', afterSales: '申请售后', restart: '再次发起', restartConfirm: '确认继续', restartModify: '修改需求', restartDecline: '暂不继续', restartProcessing: '处理中…', restartTitle: '再次发起这笔询盘？', restartDescription: '您可以直接恢复原询盘，或先补充产品与需求。原取消记录会继续保留。', archive: '删除交易', archiveInquiry: '删除询盘', deleteOrder: '删除订单', deleteBusiness: '删除业务', archiving: '删除中…',
      receiptOrder: (number) => `当前订单：${number}`,
      receiptDescription: '请确认您已收到当前订单。确认后业务将进入“已完成”。',
      receiptAfterSales: '完成后仍可申请售后。',
      receiptFailed: '暂时无法确认收货，请刷新订单状态后重试。',
      afterSalesOrder: (number) => `当前订单：${number}`,
      afterSalesCase: '售后单号', afterSalesOrderNumber: '关联订单', afterSalesType: '售后类型', afterSalesStatus: '处理状态', refundStatus: '退款状态', afterSalesDescription: '客户说明', afterSalesHistory: '售后历史', viewAfterSales: '查看售后事件', submittingAfterSales: '提交中…',
      afterSalesTypes: { logistics: '物流问题', product: '产品问题', quality: '质量问题', refund: '退款', return: '退货', exchange: '换货', other: '其它' },
      afterSalesStatuses: { submitted: '已提交', processing: '处理中', awaiting_customer: '待客户补充', resolved: '已解决', closed: '已关闭' },
      operationFailed: '暂时无法完成此操作，请稍后重试。',
      restartCreated: '新的待付款订单已创建。', noActivity: '暂无最新动态。',
      cancelDescription: (name) => `确认取消订单 ${name}？取消后该待付款订单将失效，但不会删除您的历史消息和业务记录。`,
      cancelInquiryDescription: (name) => `确认取消业务 ${name} 的询盘？取消后该询盘将保留为历史记录。`,
      cancelFailed: '暂时无法取消该订单，请刷新后重试或联系您的客户经理。', alreadyCancelled: '该订单已经取消，页面将为您刷新。',
      archiveConfirm: '若员工尚未删除，本次仅从您的业务列表隐藏；若员工已删除，系统将进行最终安全审计。正式交易与沟通记录不会被误删。',
      reason: { not_purchasing_now: '暂不采购', price_issue: '价格原因', requirements_changed: '需求变更', terms_need_review: '数量或价格需要重新确认', duplicate_inquiry: '重复询盘', no_longer_needed: '暂无需求', other: '其他' },
      events: { inquiry_created: '询盘已创建', inquiry_cancelled: '询盘已取消', inquiry_restarted: '询盘已重新发起', inquiry_restart_requested: '已申请恢复询盘', inquiry_restart_confirmation_requested: '等待客户重新确认', inquiry_restart_declined: '客户暂不恢复询盘', inquiry_reopened: '询盘已重新发起', project_created: '业务已建立', draft_order_created: '起草订单已创建', draft_order_published: '订单已发送', draft_order_cancelled: '订单已取消', draft_order_reopened: '订单已恢复付款', payment_completed: '付款已完成', order_created: '正式订单已创建', shipment_created: '订单已发货', project_completed: '业务已完成', after_sales_opened: '售后事件已提交', after_sales_processing: '售后事件处理中', after_sales_awaiting_customer: '售后事件等待补充', after_sales_resolved: '售后事件已解决', after_sales_closed: '售后事件已关闭', business_reference: '已在消息中引用业务' },
      avatarTypeInvalid: '请选择 PNG、JPEG 或 WebP 图片。', avatarTooLarge: '头像图片不能超过 2 MB。', avatarFailed: '头像暂时无法更新，请稍后重试。', avatarUploaded: '头像已更新。', avatarSyncing: '头像已上传，正在同步。', uploadAvatar: '上传头像', replaceAvatar: '更换头像', uploadingAvatar: '正在上传…',
    },
    en: {
      categories: { active: 'Active', inquiry: 'Inquiry', pending_payment: 'Pending payment', paid: 'Paid', awaiting_receipt: 'Awaiting receipt', completed: 'Completed', after_sales: 'After-sales', cancelled: 'Cancelled', all: 'All' },
      empty: { active: 'No active business.', all: 'No business records yet.', inquiry: 'No active inquiries.', pending_payment: 'No pending-payment transactions.', paid: 'No paid transactions.', awaiting_receipt: 'No transactions awaiting receipt.', completed: 'No completed transactions.', after_sales: 'No after-sales records.', cancelled: 'No cancelled transactions.' }, unavailable: 'Your business information is temporarily unavailable.',
      businessReference: 'Business reference', draftOrderNumber: 'Draft order', orderNumber: 'Order number', quantity: 'Quantity', amount: 'Amount', updated: 'Last updated', cancelledAt: 'Cancelled', completedAt: 'Completed', manager: 'Account manager', paymentStatus: 'Payment status', fulfillmentStatus: 'Fulfillment status', shippingStatus: 'Shipping status', trackingCompany: 'Carrier', trackingNumber: 'Tracking number',
      logistics: 'Shipment details', shippedAt: 'Shipped', handedOverAt: 'Handed over', deliveredAt: 'Delivered', trackingPending: 'Tracking details pending', viewPackage: 'View tracking', responsibilityEnded: 'Our logistics responsibility is complete.', handedOverResponsibilityEnded: 'Handed over to your nominated forwarder. Our logistics responsibility is complete.', packageLabel: (index) => `Package ${index}`,
      logisticsTypes: { domestic: 'Domestic transport', international: 'International transport', last_mile: 'Last-mile delivery', other: 'Transport' },
      logisticsStatuses: { pending: 'Pending shipment', shipped: 'Shipped', in_transit: 'In transit', handed_over: 'Handed over', delivered: 'Delivered', cancelled: 'Cancelled', replaced: 'Replaced' },
      continue: 'Continue conversation', message: 'Message', pay: 'Pay now', continuePayment: 'Continue payment', continuingPayment: 'Restoring…', confirmReceipt: 'Confirm receipt', confirmingReceipt: 'Confirming…', cancel: 'Cancel order', cancelInquiry: 'Cancel inquiry', inquiryType: 'Inquiry', order: 'View order', shipping: 'View tracking', shippingUnavailable: 'Tracking unavailable', afterSales: 'Request after-sales', restart: 'Restart inquiry', restartConfirm: 'Confirm', restartModify: 'Modify requirements', restartDecline: 'Not now', restartProcessing: 'Processing…', restartTitle: 'Restart this inquiry?', restartDescription: 'You can restore the original inquiry now or update its product and requirements first. The cancellation history will remain.', archive: 'Delete transaction', archiveInquiry: 'Delete inquiry', deleteOrder: 'Delete order', deleteBusiness: 'Delete business', archiving: 'Deleting…',
      receiptOrder: (number) => `Order: ${number}`,
      receiptDescription: 'Confirm that you have received this order. The business will move to Completed.',
      receiptAfterSales: 'You can still request after-sales support afterward.',
      receiptFailed: 'Receipt cannot be confirmed right now. Refresh the order status and try again.',
      afterSalesOrder: (number) => `Order: ${number}`,
      afterSalesCase: 'After-sales number', afterSalesOrderNumber: 'Order', afterSalesType: 'Support type', afterSalesStatus: 'Status', refundStatus: 'Refund status', afterSalesDescription: 'Description', afterSalesHistory: 'After-sales history', viewAfterSales: 'View after-sales event', submittingAfterSales: 'Submitting…',
      afterSalesTypes: { logistics: 'Logistics issue', product: 'Product issue', quality: 'Quality issue', refund: 'Refund', return: 'Return', exchange: 'Exchange', other: 'Other' },
      afterSalesStatuses: { submitted: 'Submitted', processing: 'Processing', awaiting_customer: 'Awaiting customer', resolved: 'Resolved', closed: 'Closed' },
      operationFailed: 'This action is temporarily unavailable. Please try again.',
      restartCreated: 'A new pending-payment order has been created.', noActivity: 'No recent activity.',
      cancelDescription: (name) => `Cancel order ${name}? The pending order will become unavailable, while your message and business history remain.`,
      cancelInquiryDescription: (name) => `Cancel the inquiry for ${name}? The inquiry will remain in your business history.`,
      cancelFailed: 'This order cannot be cancelled right now. Refresh and try again.', alreadyCancelled: 'This order is already cancelled. The page will refresh.',
      archiveConfirm: 'If Staff has not deleted this inquiry, it will only be hidden from your list. Otherwise, a final safety audit will run. Formal transaction and conversation history will be preserved.',
      reason: { not_purchasing_now: 'Not purchasing at this time', price_issue: 'Price issue', requirements_changed: 'Requirements changed', terms_need_review: 'Quantity or price needs review', duplicate_inquiry: 'Duplicate inquiry', no_longer_needed: 'No longer needed', other: 'Other' },
      events: { inquiry_created: 'Inquiry created', inquiry_cancelled: 'Inquiry cancelled', inquiry_restarted: 'Inquiry restarted', inquiry_restart_requested: 'Inquiry restart requested', inquiry_restart_confirmation_requested: 'Awaiting customer reconfirmation', inquiry_restart_declined: 'Inquiry restart declined', inquiry_reopened: 'Inquiry reopened', project_created: 'Business created', draft_order_created: 'Draft order created', draft_order_published: 'Order sent', draft_order_cancelled: 'Order cancelled', draft_order_reopened: 'Payment resumed', payment_completed: 'Payment completed', order_created: 'Formal order created', shipment_created: 'Order shipped', project_completed: 'Business completed', after_sales_opened: 'After-sales event submitted', after_sales_processing: 'After-sales event processing', after_sales_awaiting_customer: 'Awaiting customer information', after_sales_resolved: 'After-sales event resolved', after_sales_closed: 'After-sales event closed', business_reference: 'Business referenced in messages' },
      avatarTypeInvalid: 'Choose a PNG, JPEG or WebP image.', avatarTooLarge: 'The avatar image must be no larger than 2 MB.', avatarFailed: 'Your avatar cannot be updated right now.', avatarUploaded: 'Your avatar has been updated.', avatarSyncing: 'Your avatar was uploaded and is syncing.', uploadAvatar: 'Upload avatar', replaceAvatar: 'Replace avatar', uploadingAvatar: 'Uploading…',
    },
  };

  roots.forEach((root) => {
    const locale = root.dataset.locale || 'en';
    const t = locale.toLowerCase().startsWith('zh') ? copy.zh : copy.en;
    const cancellationReasonLabel = (reason) => t.reason[String(reason || '').trim()] || String(reason || '').trim();
    const apiUrl = root.dataset.apiUrl;
    const storefrontRoot = window.Shopify?.routes?.root || '/';
    const inquiryUrl = root.dataset.inquiryUrl || `${storefrontRoot.replace(/\/?$/, '/')}pages/send-inquiry`;
    const iconPrefix = root.dataset.iconPrefix;
    const dashboard = root.querySelector('[data-dashboard]');
    const states = Object.fromEntries([...root.querySelectorAll('[data-state]')].map((node) => [node.dataset.state, node]));
    const list = root.querySelector('[data-business-list]');
    const filters = [...root.querySelectorAll('[data-business-filter]')];
    const cancelDialog = root.querySelector('[data-cancel-dialog]');
    const cancelForm = root.querySelector('[data-cancel-form]');
    const cancelReason = root.querySelector('[data-cancel-reason]');
    const cancelError = root.querySelector('[data-cancel-error]');
    const receiptDialog = root.querySelector('[data-receipt-dialog]');
    const receiptOrder = root.querySelector('[data-receipt-order]');
    const receiptConfirm = root.querySelector('[data-receipt-confirm]');
    const receiptError = root.querySelector('[data-receipt-error]');
    const afterSalesDialog = root.querySelector('[data-after-sales-dialog]');
    const afterSalesForm = root.querySelector('[data-after-sales-form]');
    const afterSalesOrder = root.querySelector('[data-after-sales-order]');
    const afterSalesType = root.querySelector('[data-after-sales-type]');
    const afterSalesDescription = root.querySelector('[data-after-sales-description]');
    const afterSalesNative = root.querySelector('[data-after-sales-native]');
    const afterSalesSubmit = root.querySelector('[data-after-sales-submit]');
    let businesses = [];
    let activeCategory = 'active';
    let cancellableBusiness = null;
    let receiptBusiness = null;
    let receiptOpener = null;
    let afterSalesBusiness = null;
    let afterSalesOpener = null;
    let afterSalesSubmissionKey = '';
    let loadSequence = 0;
    let criticalReady = false;
    let businessRefreshTimer = 0;
    let businessRefreshInFlight = false;
    let businessRefreshQueued = false;
    const locallyArchivedInquiryGids = new Set();
    const profilePanel = root.querySelector('[data-customer-profile]');
    const avatarPreviews = [...root.querySelectorAll('[data-avatar-preview]')];
    const avatarNames = [...root.querySelectorAll('[data-avatar-name]')];
    const avatarSettingsTriggers = [...root.querySelectorAll('[data-avatar-settings-open]')];
    const avatarDialog = root.querySelector('[data-avatar-dialog]');
    const avatarDialogClose = root.querySelector('[data-avatar-dialog-close]');
    const avatarUpload = root.querySelector('[data-avatar-upload]');
    const avatarInput = root.querySelector('[data-avatar-input]');
    const avatarRemove = root.querySelector('[data-avatar-remove]');
    const avatarError = root.querySelector('[data-avatar-error]');
    const avatarUploadLabel = root.querySelector('[data-avatar-upload-label]');
    let currentProfile = null;
    let avatarRefreshSequence = 0;
    let localAvatarPreviewUrl = '';
    let avatarDialogOpener = null;

    const setState = (name) => {
      Object.entries(states).forEach(([key, node]) => { node.hidden = key !== name; });
      dashboard.hidden = name === 'auth' || name === 'error';
    };
    const formatDate = (value) => value
      ? new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(value))
      : '—';
    const formatMoney = (currency, amount) => {
      if (!currency || amount === '') return '—';
      const numeric = Number(amount);
      return `${currency} ${Number.isFinite(numeric) ? new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(numeric) : amount}`;
    };
    const create = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };
    const icon = (name, className = '') => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', `zj-my-business__icon${className ? ` ${className}` : ''}`);
      svg.setAttribute('aria-hidden', 'true');
      const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      use.setAttribute('href', `#${iconPrefix}-${name}`);
      svg.append(use);
      return svg;
    };
    const categoryIcon = (category) => ({
      inquiry: 'message',
      pending_payment: 'card',
      paid: 'check-circle',
      awaiting_receipt: 'truck',
      after_sales: 'rotate',
      completed: 'badge-check',
      cancelled: 'x-circle',
    })[category] || 'activity';
    const request = async (payload) => {
      const response = await fetch(apiUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.ok) {
        const error = new Error(result?.error?.code || 'OPERATION_FAILED');
        error.code = result?.error?.code || 'OPERATION_FAILED';
        throw error;
      }
      return result;
    };
    const renderProfile = (profile) => {
      if (!profilePanel || !profile) return;
      currentProfile = profile;
      profilePanel.hidden = false;
      const name = profile.displayName || (locale.toLowerCase().startsWith('zh') ? '客户账户' : 'Customer account');
      avatarNames.forEach((target) => { target.textContent = name; });
      avatarPreviews.forEach((target) => {
        target.replaceChildren();
        const appendFallback = () => {
          if (profile.initials) { target.textContent = profile.initials; return; }
          target.append(icon('user'));
        };
        if (profile.avatarUrl) {
          const image = document.createElement('img');
          image.src = profile.avatarUrl;
          image.alt = profile.avatarAlt || profile.displayName || '';
          image.addEventListener('error', () => { target.replaceChildren(); appendFallback(); }, { once: true });
          target.append(image);
        } else appendFallback();
      });
      const hasAvatar = Boolean(profile.avatarId || profile.avatarUrl);
      avatarRemove.hidden = !hasAvatar;
      avatarUploadLabel.textContent = hasAvatar ? t.replaceAvatar : t.uploadAvatar;
      avatarError.hidden = true;
      document.dispatchEvent(new CustomEvent('project-zj:customer-avatar-updated', { detail: { profile } }));
    };
    const setAvatarBusy = (busy) => {
      if (avatarUpload) {
        avatarUpload.disabled = busy;
        avatarUpload.setAttribute('aria-busy', String(busy));
      }
      if (avatarRemove) avatarRemove.disabled = busy;
      if (avatarUploadLabel) {
        avatarUploadLabel.textContent = busy
          ? t.uploadingAvatar
          : currentProfile?.avatarId || currentProfile?.avatarUrl ? t.replaceAvatar : t.uploadAvatar;
      }
    };
    const showAvatarMessage = (message, tone = 'error') => {
      if (!avatarError) return;
      avatarError.textContent = message;
      avatarError.dataset.tone = tone;
      avatarError.hidden = false;
    };
    const releaseLocalAvatarPreview = (previewUrl = localAvatarPreviewUrl) => {
      if (!previewUrl) return;
      URL.revokeObjectURL(previewUrl);
      if (localAvatarPreviewUrl === previewUrl) localAvatarPreviewUrl = '';
    };
    const refreshUploadedAvatar = async (avatarId, sequence, previewUrl = '') => {
      for (let attempt = 0; attempt < AVATAR_PROFILE_REFRESH_ATTEMPTS; attempt += 1) {
        await new Promise((resolve) => window.setTimeout(resolve, AVATAR_PROFILE_REFRESH_INTERVAL_MS));
        if (sequence !== avatarRefreshSequence) return false;
        try {
          const { response, result } = await fetchSection('profile');
          if (response.ok && result?.profile?.avatarId === avatarId && result.profile.avatarUrl) {
            releaseLocalAvatarPreview(previewUrl);
            renderProfile(result.profile);
            return true;
          }
        } catch {
          // Shopify may still be processing the uploaded MediaImage.
        }
      }
      return false;
    };
    const loadProfile = async () => {
      const { response, result } = await fetchSection('profile');
      if (!response.ok || !result?.profile) return;
      renderProfile(result.profile);
      if (result.profile.processing && result.profile.avatarId) {
        const sequence = ++avatarRefreshSequence;
        void refreshUploadedAvatar(result.profile.avatarId, sequence);
      }
    };
    const openAvatarSettings = (trigger) => {
      if (!avatarDialog?.showModal) return;
      avatarDialogOpener = trigger;
      avatarError.hidden = true;
      if (!avatarDialog.open) avatarDialog.showModal();
    };
    avatarSettingsTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => openAvatarSettings(trigger));
    });
    avatarDialogClose?.addEventListener('click', () => avatarDialog.close());
    avatarDialog?.addEventListener('close', () => {
      avatarDialogOpener?.focus();
      avatarDialogOpener = null;
    });
    avatarUpload?.addEventListener('click', () => {
      if (!avatarInput || avatarUpload.disabled) return;
      avatarError.hidden = true;
      avatarInput.value = '';
      avatarInput.click();
    });
    avatarInput?.addEventListener('change', async () => {
      const file = avatarInput.files?.[0];
      if (!file) return;
      avatarError.hidden = true;
      if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size <= 0) {
        showAvatarMessage(t.avatarTypeInvalid);
        avatarInput.value = '';
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        showAvatarMessage(t.avatarTooLarge);
        avatarInput.value = '';
        return;
      }
      const form = new FormData();
      form.set('operation', 'avatar_upload');
      form.set('avatar', file);
      const previousProfile = currentProfile;
      avatarRefreshSequence += 1;
      releaseLocalAvatarPreview();
      const previewUrl = URL.createObjectURL(file);
      localAvatarPreviewUrl = previewUrl;
      renderProfile({
        ...(currentProfile || {}),
        avatarUrl: previewUrl,
        avatarAlt: currentProfile?.displayName || file.name,
      });
      setAvatarBusy(true);
      try {
        const response = await fetch(apiUrl, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: form });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result?.profile) {
          const error = new Error(result?.error?.code || 'AVATAR_UPLOAD_FAILED');
          error.code = result?.error?.code || 'AVATAR_UPLOAD_FAILED';
          throw error;
        }
        if (result.profile.avatarUrl) {
          releaseLocalAvatarPreview(previewUrl);
          renderProfile(result.profile);
          showAvatarMessage(t.avatarUploaded, 'success');
        } else {
          renderProfile({ ...result.profile, avatarUrl: previewUrl });
          showAvatarMessage(t.avatarSyncing, 'success');
          const sequence = ++avatarRefreshSequence;
          void refreshUploadedAvatar(result.profile.avatarId, sequence, previewUrl)
            .then((ready) => { if (ready) showAvatarMessage(t.avatarUploaded, 'success'); });
        }
      } catch (error) {
        avatarRefreshSequence += 1;
        releaseLocalAvatarPreview(previewUrl);
        if (previousProfile) renderProfile(previousProfile);
        showAvatarMessage(error?.code === 'FILE_TOO_LARGE'
          ? t.avatarTooLarge
          : error?.code === 'UNSUPPORTED_FILE_TYPE'
            ? t.avatarTypeInvalid
            : error?.code === 'INVALID_AVATAR_DIMENSIONS'
              ? t.avatarTypeInvalid
              : t.avatarFailed);
      } finally {
        setAvatarBusy(false);
        avatarInput.value = '';
      }
    });
    avatarRemove?.addEventListener('click', async () => {
      avatarRefreshSequence += 1;
      releaseLocalAvatarPreview();
      avatarRemove.disabled = true;
      try { const result = await request({ operation: 'avatar_delete' }); renderProfile(result.profile); }
      catch { showAvatarMessage(t.avatarFailed); }
      finally { avatarRemove.disabled = false; }
    });
    const localBusinessReference = (business) => ({
      referenceType: business.referenceType === 'shopify_order' ? 'order' : business.referenceType,
      referenceId: business.referenceId,
      displayNumber: business.displayNumber,
      title: business.title,
      status: String(business.caseStatus || business.category || '').toUpperCase(),
      amount: business.totalAmount,
      currency: business.currency,
      businessReference: business.projectReference,
      createdAt: business.createdAt,
      imageUrl: business.imageUrl,
      imageAlt: business.imageAlt,
    });
    const openMessages = (opener, transactionKey, messageBody = '', business = null, referenceOverrides = null) => {
      document.dispatchEvent(new CustomEvent('project-zj:open-messages', {
        detail: {
          opener,
          transactionKey,
          messageBody,
          ...(business ? {
            businessReference: {
              ...localBusinessReference(business),
              ...(referenceOverrides && typeof referenceOverrides === 'object' ? referenceOverrides : {}),
            },
          } : {}),
        },
      }));
    };
    const button = (label, variant, handler, iconName = '') => {
      const control = create('button', `zj-my-business__button zj-my-business__button--${variant}`, label);
      control.type = 'button';
      if (iconName) control.prepend(icon(iconName));
      control.addEventListener('click', handler);
      return control;
    };
    const fact = (facts, label, value, iconName = '') => {
      if (!value && value !== 0) return;
      const wrapper = create('div');
      const term = create('dt');
      if (iconName) term.append(icon(iconName));
      term.append(document.createTextNode(label));
      wrapper.append(term, create('dd', '', String(value)));
      facts.append(wrapper);
    };
    const productThumbnail = (source, alt = '') => {
      const frame = create('span', 'zj-my-business__product-thumbnail');
      if (!source) {
        frame.classList.add('is-placeholder');
        frame.append(icon('package'));
        return frame;
      }
      const image = document.createElement('img');
      image.src = source;
      image.alt = alt;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', () => {
        frame.replaceChildren(icon('package'));
        frame.classList.add('is-placeholder');
      }, { once: true });
      frame.append(image);
      return frame;
    };
    const localizedStatus = (value) => {
      const labels = locale.toLowerCase().startsWith('zh')
        ? { paid: '已付款', unfulfilled: '未发货', fulfilled: '已发货', partially_fulfilled: '部分发货', in_transit: '运输中', out_for_delivery: '派送中', delivered: '已送达', success: '已发货', '已付款': '已付款', '未发货': '未发货', '已发货': '已发货' }
        : { paid: 'Paid', unfulfilled: 'Unfulfilled', fulfilled: 'Fulfilled', partially_fulfilled: 'Partially fulfilled', in_transit: 'In transit', out_for_delivery: 'Out for delivery', delivered: 'Delivered', success: 'Shipped', '已付款': 'Paid', '未发货': 'Unfulfilled', '已发货': 'Fulfilled' };
      return labels[String(value || '').toLowerCase()] || value;
    };

    let restartBusiness = null;
    let restartOpener = null;
    const restartDialog = create('dialog', 'zj-my-business__dialog');
    const restartPanel = create('div', 'zj-my-business__dialog-panel');
    const restartHeading = create('div');
    restartHeading.append(
      create('h2', '', t.restartTitle),
      create('p', '', t.restartDescription),
    );
    const restartActions = create('div', 'zj-my-business__dialog-actions');
    const restartConfirmControl = button(t.restartConfirm, 'primary', () => {
      if (restartBusiness) void confirmInquiryRestart(restartBusiness, restartConfirmControl);
    }, 'check-circle');
    const restartModifyControl = button(t.restartModify, 'secondary', () => {
      if (!restartBusiness) return;
      const business = restartBusiness;
      restartDialog.close();
      const url = new URL(inquiryUrl, window.location.origin);
      url.searchParams.set('mode', 'restart-edit');
      url.searchParams.set('inquiry', business.inquiryGid);
      window.location.assign(url.toString());
    }, 'message');
    const restartDeclineControl = button(t.restartDecline, 'text', () => {
      restartDialog.close();
    }, 'x-circle');
    restartActions.append(restartDeclineControl, restartModifyControl, restartConfirmControl);
    restartPanel.append(restartHeading, restartActions);
    restartDialog.append(restartPanel);
    restartDialog.addEventListener('close', () => {
      restartOpener?.focus();
      restartBusiness = null;
      restartOpener = null;
    });
    root.append(restartDialog);
    const openRestartConfirmation = (business, opener) => {
      restartBusiness = business;
      restartOpener = opener;
      if (restartDialog.showModal) restartDialog.showModal();
      else restartDialog.setAttribute('open', '');
    };

    const openPayment = async (business, control) => {
      if (control.disabled) return;
      control.disabled = true;
      try {
        const result = await request({ operation: 'payment', project: business.project });
        window.location.assign(result.url);
      } catch { window.alert(t.operationFailed); }
      finally { control.disabled = false; }
    };
    const continuePayment = async (business, control) => {
      if (control.disabled) return;
      const originalText = control.textContent;
      control.disabled = true;
      control.textContent = t.continuingPayment;
      try {
        const result = await request({
          operation: 'continue_payment',
          inquiryGid: business.inquiryGid,
          draftOrderGid: business.referenceId,
        });
        const continuation = result.continuation;
        if (!continuation?.invoiceUrl) throw new Error('PAYMENT_URL_NOT_AVAILABLE');
        businesses = businesses.map((candidate) => candidate.inquiryGid === business.inquiryGid
          ? {
              ...candidate,
              ...continuation.transaction,
              category: 'pending_payment',
              lifecycleCategory: 'pending_payment',
              status: t.categories.pending_payment,
              lifecycleStatus: t.categories.pending_payment,
              restartState: 'reopened',
              cancelledAt: '',
              cancellationReason: '',
            }
          : candidate);
        renderBusinesses();
        window.location.assign(continuation.invoiceUrl);
      } catch {
        window.alert(t.operationFailed);
        control.disabled = false;
        control.textContent = originalText;
      }
    };
    const confirmInquiryRestart = async (business, control) => {
      if (control.disabled) return;
      const previous = { ...business };
      const originalText = control.textContent;
      control.disabled = true;
      control.textContent = t.restartProcessing;
      try {
        const result = await request({
          operation: 'confirm_inquiry_restart',
          referenceId: business.inquiryGid || business.referenceId,
        });
        if (result.restart?.state === 'reopened') {
          business.transactionKey = `inquiry:${business.inquiryGid}`;
          business.referenceType = 'inquiry';
          business.referenceId = business.inquiryGid;
          business.displayNumber = result.restart.inquiryId || business.displayNumber;
          business.restartState = 'reopened';
          business.category = 'inquiry';
          business.lifecycleCategory = 'inquiry';
          business.status = locale.toLowerCase().startsWith('zh') ? '询盘中' : 'Inquiry';
          business.lifecycleStatus = business.status;
          business.canCancelInquiry = result.restart.canCancel === true;
          business.canCancelBusiness = false;
          business.canApplyAfterSales = false;
          business.canContinuePayment = false;
          business.canRestartInquiry = false;
          business.canArchiveInquiry = false;
          business.canMessage = true;
          business.cancelledAt = '';
          business.cancellationReason = '';
          business.updatedAt = result.restart.event?.createdAt || new Date().toISOString();
        }
        renderBusinesses();
        if (restartDialog.open) restartDialog.close();
      } catch {
        Object.assign(business, previous);
        renderBusinesses();
        window.alert(t.operationFailed);
      } finally {
        control.disabled = false;
        control.textContent = originalText;
      }
    };
    document.addEventListener('project-zj:inquiry-restart-decision', (event) => {
      const inquiryGid = event.detail?.inquiryGid || '';
      const decision = event.detail?.decision || '';
      const business = businesses.find((candidate) => candidate.inquiryGid === inquiryGid);
      if (!business || !['confirm', 'modify', 'decline'].includes(decision)) return;
      const control = event.detail?.opener || { disabled: false, textContent: '' };
      if (decision === 'confirm') {
        void confirmInquiryRestart(business, control);
      } else if (decision === 'modify') {
        const url = new URL(inquiryUrl, window.location.origin);
        url.searchParams.set('mode', 'restart-edit');
        url.searchParams.set('inquiry', business.inquiryGid);
        window.location.assign(url.toString());
      }
    });
    const archive = async (business, control) => {
      if (!window.confirm(t.archiveConfirm)) return;
      const originalContent = [...control.childNodes];
      control.disabled = true;
      control.replaceChildren(icon('trash'), document.createTextNode(t.archiving));
      try {
        const result = await request({
          operation: 'archive',
          transactionKey: business.transactionKey,
          inquiryGid: business.inquiryGid,
        });
        if (
          !['customer_hidden', 'hard_deleted', 'protected_archived'].includes(result.disposition) ||
          result.inquiryGid !== business.inquiryGid
        ) throw new Error('ARCHIVE_RESULT_MISMATCH');
        locallyArchivedInquiryGids.add(result.inquiryGid);
        businesses = businesses.filter((candidate) =>
          candidate.inquiryGid !== result.inquiryGid
        );
        renderBusinesses();
      } catch { window.alert(t.operationFailed); }
      finally {
        if (control.isConnected) {
          control.replaceChildren(...originalContent);
          control.disabled = false;
        }
      }
    };
    const openReceiptConfirmation = (business, opener) => {
      receiptBusiness = business;
      receiptOpener = opener;
      receiptOrder.textContent = t.receiptOrder(business.displayNumber);
      receiptError.hidden = true;
      if (receiptDialog.showModal) receiptDialog.showModal(); else receiptDialog.setAttribute('open', '');
    };
    const openAfterSales = (business, opener) => {
      afterSalesBusiness = business;
      afterSalesOpener = opener;
      afterSalesOrder.textContent = t.afterSalesOrder(business.displayNumber);
      afterSalesType.value = '';
      afterSalesDescription.value = '';
      afterSalesSubmissionKey = window.crypto?.randomUUID?.() || `${Date.now()}_${Math.random().toString(36).slice(2)}`;
      afterSalesNative.hidden = true;
      if (afterSalesDialog.showModal) afterSalesDialog.showModal(); else afterSalesDialog.setAttribute('open', '');
    };

    const logisticsRoute = (leg) => {
      const origin = String(leg?.origin || '').trim();
      const destination = String(leg?.destination || '').trim();
      return origin && destination ? `${origin} → ${destination}` : origin || destination;
    };
    const logisticsTime = (list, label, value) => {
      if (!value) return;
      const row = create('div');
      row.append(create('dt', '', label), create('dd', '', formatDate(value)));
      list.append(row);
    };
    const renderLogisticsTracking = (tracking, index, count) => {
      const row = create('li', 'zj-my-business__tracking');
      if (count > 1) row.append(create('strong', '', t.packageLabel(index + 1)));
      row.append(create('span', '', [tracking.carrier, tracking.trackingNumber].filter(Boolean).join(' · ') || t.trackingPending));
      if (tracking.trackingUrl) {
        const link = create('a', '', t.viewPackage);
        link.href = tracking.trackingUrl;
        link.target = '_blank';
        link.rel = 'noreferrer';
        row.append(link);
      }
      return row;
    };
    const renderLogisticsLeg = (leg, timeline) => {
      const item = create('article', `zj-my-business__logistics-leg${timeline ? ' is-timeline' : ''}`);
      const head = create('header');
      head.append(
        create('strong', '', t.logisticsTypes[leg.type] || t.logisticsTypes.other),
        create('span', `is-${leg.status || 'pending'}`, t.logisticsStatuses[leg.status] || leg.status || t.logisticsStatuses.pending),
      );
      item.append(head);
      const route = logisticsRoute(leg);
      if (route) item.append(create('p', 'zj-my-business__logistics-route', route));
      const times = create('dl', 'zj-my-business__logistics-times');
      logisticsTime(times, t.shippedAt, leg.shippedAt);
      logisticsTime(times, t.handedOverAt, leg.handedOverAt);
      logisticsTime(times, t.deliveredAt, leg.deliveredAt);
      if (times.children.length) item.append(times);
      const trackings = Array.isArray(leg.trackings) ? leg.trackings : [];
      if (trackings.length) {
        const list = create('ul', 'zj-my-business__trackings');
        trackings.forEach((tracking, index) => list.append(renderLogisticsTracking(tracking, index, trackings.length)));
        item.append(list);
      }
      if (leg.responsibilityEndsHere && ['handed_over', 'delivered'].includes(leg.status)) {
        item.append(create(
          'p',
          'zj-my-business__logistics-responsibility',
          leg.status === 'handed_over' ? t.handedOverResponsibilityEnded : t.responsibilityEnded,
        ));
      }
      return item;
    };
    const renderLogistics = (legs) => {
      if (legs.length === 1) {
        const single = create('section', 'zj-my-business__logistics is-single');
        single.setAttribute('aria-label', t.logistics);
        single.append(renderLogisticsLeg(legs[0], false));
        return single;
      }
      const details = create('details', 'zj-my-business__logistics is-timeline');
      details.append(create('summary', '', t.shipping));
      const timeline = create('div', 'zj-my-business__logistics-timeline');
      legs.forEach((leg) => timeline.append(renderLogisticsLeg(leg, true)));
      details.append(timeline);
      return details;
    };

    const renderCard = (business) => {
      const lifecycleCategory = business.lifecycleCategory || business.category;
      const logisticsLegs = Array.isArray(business.logisticsLegs) ? business.logisticsLegs : [];
      const card = create('article', `zj-my-business__transaction zj-my-business__transaction--${business.category}`);
      const header = create('div', 'zj-my-business__transaction-head');
      const heading = create('div', 'zj-my-business__transaction-heading');
      heading.append(
        productThumbnail(business.imageUrl, business.imageAlt || business.title),
        create('h2', '', business.title || t.categories[business.category]),
      );
      const status = create('span', 'zj-my-business__transaction-status');
      status.append(icon(categoryIcon(business.category)), document.createTextNode(t.categories[business.category] || business.status));
      header.append(heading, status);
      card.append(header);
      const items = Array.isArray(business.lineItems) ? business.lineItems : [];
      if (items.length > 1) {
        const itemList = create('ul', 'zj-my-business__transaction-items');
        items.forEach((item) => itemList.append(create('li', '', `${item.product} × ${item.quantity}`)));
        card.append(itemList);
      }
      const facts = create('dl', 'zj-my-business__transaction-facts');
      if (business.referenceType === 'inquiry') {
        fact(facts, t.inquiryType, t.categories.inquiry, 'message');
        fact(facts, t.businessReference, business.projectReference, 'hash');
      }
      else fact(facts, business.referenceType === 'draft_order' ? t.draftOrderNumber : t.orderNumber, business.displayNumber, 'package');
      if (business.quantity > 0) fact(facts, t.quantity, business.quantity, 'package');
      if (business.currency) fact(facts, t.amount, formatMoney(business.currency, business.totalAmount), 'amount');
      fact(facts, business.category === 'cancelled' ? t.cancelledAt : business.category === 'completed' ? t.completedAt : t.updated, formatDate(business.cancelledAt || business.updatedAt), 'clock');
      if (business.category === 'inquiry' && business.representativeName) fact(facts, t.manager, business.representativeName, 'user');
      if (lifecycleCategory === 'paid') {
        fact(facts, t.paymentStatus, localizedStatus(business.paymentStatus || t.categories.paid), 'check-circle');
        fact(facts, t.fulfillmentStatus, localizedStatus(business.fulfillmentStatus), 'package');
      }
      if (lifecycleCategory === 'awaiting_receipt') {
        if (!logisticsLegs.length) {
          fact(facts, t.shippingStatus, localizedStatus(business.shipmentStatus || business.fulfillmentStatus || business.status), 'truck');
          fact(facts, t.trackingCompany, business.trackingCompany, 'truck');
          fact(facts, t.trackingNumber, business.trackingNumber, 'hash');
        }
      }
      if (business.cancellationReason) fact(facts, locale.toLowerCase().startsWith('zh') ? '取消原因' : 'Cancellation reason', cancellationReasonLabel(business.cancellationReason));
      card.append(facts);
      if (business.referenceType === 'shopify_order' && logisticsLegs.length) {
        card.append(renderLogistics(logisticsLegs));
      }
      const activeAfterSales = Array.isArray(business.afterSalesCases) ? business.afterSalesCases : [];
      if (activeAfterSales.length) {
        const active = create('details', 'zj-my-business__after-sales-history is-active');
        active.open = true;
        active.append(create('summary', '', `${t.categories.after_sales} ${activeAfterSales.length}`));
        const rows = create('ul');
        activeAfterSales.forEach((item) => {
          const row = create('li');
          row.append(
            create('strong', '', item.caseId),
            create('span', '', t.afterSalesTypes[item.requestType] || item.requestType),
            create('span', '', t.afterSalesStatuses[item.status] || item.status),
            create('time', '', formatDate(item.updatedAt)),
          );
          if (item.refundStatus === 'full') row.append(create('span', '', locale.toLowerCase().startsWith('zh') ? '已退款' : 'Refunded'));
          if (item.refundStatus === 'partial') row.append(create('span', '', locale.toLowerCase().startsWith('zh') ? '部分退款' : 'Partially refunded'));
          if (item.description) row.append(create('p', '', item.description));
          rows.append(row);
        });
        active.append(rows);
        card.append(active);
      }
      const afterSalesHistory = Array.isArray(business.afterSalesHistory) ? business.afterSalesHistory : [];
      if (business.referenceType === 'shopify_order' && afterSalesHistory.length) {
        const history = create('details', 'zj-my-business__after-sales-history is-history');
        history.append(create('summary', '', `${t.afterSalesHistory} ${afterSalesHistory.length}`));
        const rows = create('ul');
        afterSalesHistory.forEach((item) => {
          const row = create('li');
          row.append(
            create('strong', '', item.caseId),
            create('span', '', t.afterSalesTypes[item.requestType] || item.requestType),
            create('span', '', t.afterSalesStatuses[item.status] || item.status),
            create('time', '', formatDate(item.closedAt || item.resolvedAt || item.updatedAt)),
          );
          if (item.refundStatus === 'full') row.append(create('span', '', locale.toLowerCase().startsWith('zh') ? '已退款' : 'Refunded'));
          if (item.refundStatus === 'partial') row.append(create('span', '', locale.toLowerCase().startsWith('zh') ? '部分退款' : 'Partially refunded'));
          if (item.description) row.append(create('p', '', item.description));
          rows.append(row);
        });
        history.append(rows);
        card.append(history);
      }
      const actions = create('div', 'zj-my-business__transaction-actions');
      if (business.canPay) actions.append(button(t.pay, 'primary', (event) => void openPayment(business, event.currentTarget), 'card'));
      if (business.canContinuePayment) actions.append(button(t.continuePayment, 'primary', (event) => void continuePayment(business, event.currentTarget), 'card'));
      if (business.canConfirmReceipt) actions.append(button(t.confirmReceipt, 'primary', (event) => openReceiptConfirmation(business, event.currentTarget), 'badge-check'));
      if (lifecycleCategory === 'awaiting_receipt') {
        if (!logisticsLegs.length && business.trackingUrl) {
          actions.append(button(t.shipping, 'secondary', () => window.location.assign(business.trackingUrl), 'truck'));
        } else if (!logisticsLegs.length) {
          const unavailable = button(t.shippingUnavailable, 'secondary-outline', () => {}, 'truck');
          unavailable.disabled = true;
          actions.append(unavailable);
        }
      }
      if (['paid', 'awaiting_receipt', 'completed'].includes(lifecycleCategory) && business.referenceType === 'shopify_order') actions.append(button(t.order, 'secondary', () => window.location.assign(root.dataset.ordersUrl), 'grid'));
      if (business.canApplyAfterSales && business.referenceType === 'shopify_order') actions.append(button(t.afterSales, 'secondary-outline', (event) => openAfterSales(business, event.currentTarget), 'rotate'));
      if (business.canRestartInquiry && business.referenceType === 'inquiry') actions.append(button(t.restart, 'primary', (event) => {
        openRestartConfirmation(business, event.currentTarget);
      }, 'rotate'));
      if (business.canMessage) actions.append(button(lifecycleCategory === 'inquiry' ? t.continue : t.message, 'secondary', (event) => openMessages(event.currentTarget, business.transactionKey, '', business), 'message'));
      if (business.canCancelInquiry || business.canCancelBusiness) actions.append(button(business.canCancelInquiry ? t.cancelInquiry : t.cancel, 'cancel', () => {
        cancellableBusiness = business;
        cancelReason.value = '';
        cancelError.hidden = true;
        root.querySelector('[data-cancel-title]').textContent = business.canCancelInquiry ? t.cancelInquiry : t.cancel;
        root.querySelector('[data-cancel-description]').textContent = business.canCancelInquiry
          ? t.cancelInquiryDescription(business.displayNumber)
          : t.cancelDescription(business.displayNumber);
        if (cancelDialog.showModal) cancelDialog.showModal(); else cancelDialog.setAttribute('open', '');
      }, 'x-circle'));
      if (business.canArchiveInquiry) actions.append(button(
        business.category === 'completed'
          ? t.deleteBusiness
          : business.canContinuePayment ? t.deleteOrder : t.archiveInquiry,
        'text',
        (event) => void archive(business, event.currentTarget),
        'trash',
      ));
      card.append(actions);
      return card;
    };

    afterSalesType?.addEventListener('change', () => {
      afterSalesNative.hidden = !['refund', 'return', 'exchange'].includes(afterSalesType.value);
    });
    root.querySelector('[data-after-sales-return]')?.addEventListener('click', () => afterSalesDialog.close());
    afterSalesDialog?.addEventListener('close', () => {
      afterSalesOpener?.focus();
      afterSalesBusiness = null;
      afterSalesOpener = null;
      afterSalesSubmissionKey = '';
    });
    afterSalesForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!afterSalesBusiness || !afterSalesForm.reportValidity() || afterSalesSubmit.disabled) return;
      const opener = afterSalesOpener;
      const business = afterSalesBusiness;
      const description = afterSalesDescription.value.trim();
      const originalLabel = afterSalesSubmit.textContent;
      afterSalesSubmit.disabled = true;
      afterSalesSubmit.textContent = t.submittingAfterSales;
      try {
        const result = await request({
          operation: 'after_sales_open',
          inquiryGid: business.inquiryGid,
          orderGid: business.referenceId,
          requestType: afterSalesType.value,
          description,
          submissionKey: afterSalesSubmissionKey,
        });
        if (result.business) {
          businesses = [result.business, ...businesses.filter((item) => item.inquiryGid !== result.business.inquiryGid)];
          activeCategory = 'after_sales';
          filters.forEach((filter) => filter.setAttribute('aria-current', String(filter.dataset.businessFilter === 'after_sales')));
          renderBusinesses();
        }
        afterSalesDialog.close();
        openMessages(opener);
        void load();
      } catch { window.alert(t.operationFailed); }
      finally {
        afterSalesSubmit.disabled = false;
        afterSalesSubmit.textContent = originalLabel;
      }
    });

    const renderBusinesses = () => {
      const activeLifecycleCategories = ['inquiry', 'pending_payment', 'paid', 'awaiting_receipt'];
      const hasActiveAfterSales = (business) => Array.isArray(business.afterSalesCases) && business.afterSalesCases.length > 0;
      const matchesCategory = (business, category) => {
        const lifecycleCategory = business.lifecycleCategory || business.category;
        if (category === 'all') return true;
        if (category === 'after_sales') return hasActiveAfterSales(business);
        if (category === 'active') return activeLifecycleCategories.includes(lifecycleCategory) || hasActiveAfterSales(business);
        return lifecycleCategory === category;
      };
      const visible = businesses.filter((business) => matchesCategory(business, activeCategory));
      list.replaceChildren();
      list.setAttribute('aria-busy', 'false');
      if (!visible.length) list.append(create('p', 'zj-my-business__empty', t.empty[activeCategory] || t.empty.all));
      else visible.forEach((business) => list.append(renderCard(business)));
      root.querySelectorAll('[data-filter-count]').forEach((node) => {
        const category = node.dataset.filterCount;
        node.textContent = String(businesses.filter((business) => matchesCategory(business, category)).length);
      });
      root.querySelectorAll('[data-overview-count]').forEach((node) => {
        node.textContent = String(businesses.filter((business) => matchesCategory(business, node.dataset.overviewCount)).length);
      });
    };

    const normalizeCurrentBusinessCapabilities = (business) => {
      const paymentStatus = String(business?.paymentStatus || '').toUpperCase();
      const hasPaidOrder = business?.referenceType === 'shopify_order' ||
        ['PAID', '已付款'].includes(paymentStatus);
      return hasPaidOrder
        ? {
            ...business,
            canPay: false,
            canContinuePayment: false,
            canCancelBusiness: false,
          }
        : business;
    };

    const mergeCriticalBusinesses = (incomingBusinesses) => {
      const existingByInquiry = new Map(
        businesses.map((business) => [business.inquiryGid, business]),
      );
      return (Array.isArray(incomingBusinesses) ? incomingBusinesses : [])
        .filter((business) => !locallyArchivedInquiryGids.has(business.inquiryGid))
        .map((business) => normalizeCurrentBusinessCapabilities({
            ...(existingByInquiry.get(business.inquiryGid) || {}),
            ...business,
        }));
    };

    const dispatchCriticalBusinessSnapshot = () => {
      document.dispatchEvent(new CustomEvent('project-zj:customer-business-snapshot', {
        detail: { businesses },
      }));
    };

    const refreshCriticalBusinesses = async () => {
      if (!criticalReady) {
        businessRefreshQueued = true;
        return;
      }
      if (businessRefreshInFlight) {
        businessRefreshQueued = true;
        return;
      }
      businessRefreshInFlight = true;
      businessRefreshQueued = false;
      try {
        const { response, result } = await fetchSection('critical');
        if (!response.ok || !result?.critical) return;
        businesses = mergeCriticalBusinesses(result.critical.businesses);
        renderBusinesses();
        dispatchCriticalBusinessSnapshot();
      } catch {
        // Preserve the last successful business snapshot on background failures.
      } finally {
        businessRefreshInFlight = false;
        if (businessRefreshQueued) scheduleCriticalBusinessRefresh();
      }
    };

    function scheduleCriticalBusinessRefresh() {
      if (!criticalReady) {
        businessRefreshQueued = true;
        return;
      }
      window.clearTimeout(businessRefreshTimer);
      businessRefreshTimer = window.setTimeout(
        () => void refreshCriticalBusinesses(),
        200,
      );
    }

    document.addEventListener(
      'project-zj:customer-business-changed',
      scheduleCriticalBusinessRefresh,
    );

    filters.forEach((filter) => filter.addEventListener('click', () => {
      activeCategory = filter.dataset.businessFilter;
      filters.forEach((candidate) => candidate.setAttribute('aria-current', String(candidate === filter)));
      renderBusinesses();
      if (window.matchMedia('(max-width: 749px)').matches) {
        const strip = filter.parentElement;
        const left = filter.offsetLeft - ((strip.clientWidth - filter.offsetWidth) / 2);
        strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }));

    const closeCancelDialog = () => { if (cancelDialog?.close) cancelDialog.close(); else cancelDialog?.removeAttribute('open'); };
    root.querySelector('[data-cancel-return]')?.addEventListener('click', closeCancelDialog);
    cancelDialog?.addEventListener('cancel', (event) => { event.preventDefault(); closeCancelDialog(); });
    cancelForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const confirm = root.querySelector('[data-cancel-confirm]');
      if (!cancellableBusiness || confirm.disabled) return;
      confirm.disabled = true;
      cancelError.hidden = true;
      try {
        const cancelledBusiness = cancellableBusiness;
        const result = await request(cancelledBusiness.canCancelInquiry
          ? { operation: 'cancel_inquiry', referenceId: cancelledBusiness.referenceId, reason: cancelReason.value }
          : {
              operation: 'cancel_business',
              inquiryGid: cancelledBusiness.inquiryGid,
              draftOrderGid: cancelledBusiness.referenceId,
              reason: cancelReason.value,
            });
        closeCancelDialog();
        if (result.cancellation) {
          const cancelledAt = result.cancellation.cancelledAt || new Date().toISOString();
          const cancellationEvent = result.cancellation.event || result.cancellation.inquiryCancellation?.event;
          const cancelledSnapshot = result.cancellation.transaction || {};
          const pausedDraftOrder = cancelledSnapshot.canContinuePayment === true;
          businesses = businesses.map((business) => business.inquiryGid === cancelledBusiness.inquiryGid
            ? {
                ...business,
                ...cancelledSnapshot,
                transactionKey: cancelledSnapshot.transactionKey || `inquiry:${cancelledBusiness.inquiryGid}`,
                referenceType: cancelledSnapshot.referenceType || 'inquiry',
                referenceId: cancelledSnapshot.referenceId || cancelledBusiness.inquiryGid,
                displayNumber: cancelledSnapshot.displayNumber || result.cancellation.inquiryId || business.displayNumber,
                category: 'cancelled',
                lifecycleCategory: 'cancelled',
                status: t.categories.cancelled,
                lifecycleStatus: t.categories.cancelled,
                restartState: 'cancelled',
                canPay: false,
                canCancelInquiry: false,
                canCancelBusiness: false,
                canApplyAfterSales: false,
                canContinuePayment: pausedDraftOrder,
                canRestartInquiry: !pausedDraftOrder,
                canArchiveInquiry: true,
                canMessage: true,
                cancelledAt,
                cancellationReason: result.cancellation.cancellationReason || cancelReason.value,
                updatedAt: cancellationEvent?.createdAt || cancelledAt,
              }
            : business);
          activeCategory = 'cancelled';
          filters.forEach((filter) => filter.setAttribute(
            'aria-current',
            String(filter.dataset.businessFilter === 'cancelled'),
          ));
          renderBusinesses();
        }
      } catch (error) {
        if (error.code === 'DRAFT_ORDER_ALREADY_CANCELLED') { closeCancelDialog(); window.alert(t.alreadyCancelled); }
        else { cancelError.textContent = t.cancelFailed; cancelError.hidden = false; }
      } finally { confirm.disabled = false; }
    });

    const closeReceiptDialog = () => { if (receiptDialog?.close) receiptDialog.close(); else receiptDialog?.removeAttribute('open'); };
    root.querySelector('[data-receipt-return]')?.addEventListener('click', closeReceiptDialog);
    receiptDialog?.addEventListener('cancel', (event) => { event.preventDefault(); closeReceiptDialog(); });
    receiptDialog?.addEventListener('close', () => {
      receiptOpener?.focus();
      receiptBusiness = null;
      receiptOpener = null;
      receiptConfirm.disabled = false;
      receiptConfirm.replaceChildren(icon('badge-check'), document.createTextNode(t.confirmReceipt));
    });
    receiptConfirm?.addEventListener('click', async () => {
      if (!receiptBusiness || receiptConfirm.disabled) return;
      const completedBusiness = receiptBusiness;
      receiptConfirm.disabled = true;
      receiptConfirm.replaceChildren(icon('badge-check'), document.createTextNode(t.confirmingReceipt));
      receiptError.hidden = true;
      try {
        const result = await request({
          operation: 'confirm_receipt',
          project: completedBusiness.project,
          orderId: completedBusiness.referenceId,
        });
        const completedAt = result.completion?.projectUpdatedAt || new Date().toISOString();
        businesses = businesses.map((business) => business.inquiryGid === completedBusiness.inquiryGid
          ? { ...business, category: 'completed', status: t.categories.completed, updatedAt: completedAt, canConfirmReceipt: false, canArchiveInquiry: true }
          : business);
        activeCategory = 'completed';
        filters.forEach((filter) => filter.setAttribute('aria-current', String(filter.dataset.businessFilter === 'completed')));
        closeReceiptDialog();
        renderBusinesses();
        void load();
      } catch {
        receiptError.textContent = t.receiptFailed;
        receiptError.hidden = false;
        receiptConfirm.disabled = false;
        receiptConfirm.replaceChildren(icon('badge-check'), document.createTextNode(t.confirmReceipt));
      }
    });

    const sectionUrl = (section) => {
      const url = new URL(apiUrl, window.location.origin);
      url.searchParams.set('section', section);
      url.searchParams.set('locale', locale);
      return `${url.pathname}${url.search}`;
    };
    const fetchSection = async (section) => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch(sectionUrl(section), { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
        const result = await response.json().catch(() => null);
        return { response, result };
      } finally { window.clearTimeout(timeout); }
    };
    const renderActivity = (secondary) => {
      const activity = root.querySelector('[data-activity]');
      activity.replaceChildren();
      activity.setAttribute('aria-busy', 'false');
      const rawRecords = secondary?.overview?.recentActivities || [];
      const seen = new Set();
      const records = rawRecords.filter((record) => {
        if (record.type !== 'business_event') return true;
        const payload = record.eventPayload || {};
        const object = payload.referenceId || payload.draftOrderGid || payload.draftOrderName || record.projectReference || record.product || '';
        const minute = String(record.createdAt || '').slice(0, 16);
        const key = `${record.eventKind}:${object}:${minute}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      if (!records.length) { activity.append(create('li', 'zj-my-business__activity-empty', t.noActivity)); return; }
      records.slice(0, 5).forEach((record) => {
        const item = create('li');
        const eventIcon = record.type !== 'business_event'
          ? 'message'
          : record.eventKind === 'draft_order_cancelled'
          ? 'x-circle'
          : ['business_reference'].includes(record.eventKind)
            ? 'message'
            : ['inquiry_created', 'project_created'].includes(record.eventKind)
              ? 'message'
              : 'activity';
        item.append(icon(eventIcon, `zj-my-business__activity-icon${record.eventKind === 'draft_order_cancelled' ? ' zj-my-business__activity-icon--cancelled' : ''}`));
        const detail = create('div');
        const payload = record.eventPayload || {};
        const product = record.product || payload.title || payload.productTitle || payload.product || '';
        const number = payload.displayNumber || payload.draftOrderName || '';
        let label = record.type === 'business_event' ? t.events[record.eventKind] || record.body : record.body;
        if (record.eventKind === 'business_reference') {
          const subject = payload.referenceType === 'inquiry'
            ? (locale.toLowerCase().startsWith('zh') ? '已引用询盘' : 'Inquiry referenced')
            : `${locale.toLowerCase().startsWith('zh') ? '已引用订单' : 'Order referenced'}${number ? ` ${number}` : ''}`;
          label = `${subject}${product ? `：${product}` : ''}`;
        } else if (record.eventKind === 'inquiry_created') {
          label = `${locale.toLowerCase().startsWith('zh') ? '已提交询盘' : 'Inquiry submitted'}${product ? `：${product}` : ''}`;
        } else if (record.eventKind === 'draft_order_cancelled') {
          label = `${locale.toLowerCase().startsWith('zh') ? '订单' : 'Order'}${number ? ` ${number}` : ''} ${locale.toLowerCase().startsWith('zh') ? '已取消' : 'cancelled'}`;
        } else if (['draft_order_created', 'draft_order_published'].includes(record.eventKind)) {
          label = `${locale.toLowerCase().startsWith('zh') ? '订单' : 'Order'}${number ? ` ${number}` : ''} ${record.eventKind === 'draft_order_published' ? (locale.toLowerCase().startsWith('zh') ? '已发送' : 'sent') : (locale.toLowerCase().startsWith('zh') ? '已创建' : 'created')}${product ? ` · ${product}` : ''}`;
        }
        detail.append(create('p', '', label));
        item.append(detail, create('small', '', formatDate(record.createdAt)));
        activity.append(item);
      });
    };

    async function load() {
      const sequence = ++loadSequence;
      list.setAttribute('aria-busy', 'true');
      try {
        const criticalRequest = fetchSection('critical');
        const secondaryRequest = fetchSection('secondary');
        const { response, result } = await criticalRequest;
        if (sequence !== loadSequence) return;
        if (response.status === 401 || result?.error?.code === 'AUTH_REQUIRED') { setState('auth'); return; }
        if (!response.ok || !result?.critical) throw new Error('CRITICAL_FAILED');
        businesses = mergeCriticalBusinesses(result.critical.businesses);
        criticalReady = true;
        renderBusinesses();
        dispatchCriticalBusinessSnapshot();
        setState('ready');
        if (businessRefreshQueued) scheduleCriticalBusinessRefresh();
        const secondary = await secondaryRequest;
        if (sequence === loadSequence && secondary.response.ok) {
          const shipmentByTransaction = new Map(
            (secondary.result?.secondary?.overview?.shipments || []).map((shipment) => [shipment.transactionKey, shipment]),
          );
          if (shipmentByTransaction.size) {
            businesses = businesses.map((business) => {
              const shipment = shipmentByTransaction.get(business.transactionKey) ||
                [...shipmentByTransaction.values()].find((candidate) =>
                  candidate.referenceId === business.referenceId
                );
              return shipment
                ? {
                    ...business,
                    fulfillmentStatus: business.fulfillmentStatus || shipment.fulfillmentStatus,
                    shipmentStatus: business.shipmentStatus || shipment.shipmentStatus,
                    trackingCompany: business.trackingCompany || shipment.trackingCompany,
                    trackingNumber: business.trackingNumber || shipment.trackingNumber,
                    trackingUrl: business.trackingUrl || shipment.trackingUrl,
                  }
                : business;
            });
            renderBusinesses();
          }
          renderActivity(secondary.result?.secondary);
        }
        else if (sequence === loadSequence) renderActivity(null);
      } catch {
        if (sequence === loadSequence) setState('error');
      }
    }

    root.querySelector('[data-retry]')?.addEventListener('click', () => void load());
    setState('loading');
    void loadProfile();
    void load();
  });
})();
